import React from "react";

function Crestron() {
    return (
        <h1>
        This si the crestorn page</h1>
    );
}

export default Crestron